/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { injectIntl } from 'react-intl-next';
import { hexToRgba } from '@atlaskit/adf-schema';
import { dropPlaceholderMessages } from '@atlaskit/editor-common/media';
import DocumentFilledIcon from '@atlaskit/icon/glyph/document-filled';
import { B200, B300, B400 } from '@atlaskit/theme/colors';
import { borderRadius } from '@atlaskit/theme/constants';
import { FILE_WIDTH, MEDIA_HEIGHT } from '../../nodeviews/mediaNodeView/media';
var iconWrapperStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  color: "var(--ds-icon-accent-blue, ".concat(hexToRgba(B400, 0.4) || B400, ")"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  background: "var(--ds-background-accent-blue-subtle, ".concat(hexToRgba(B300, 0.6) || B300, ")"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  borderRadius: "".concat(borderRadius(), "px"),
  margin: "var(--ds-space-075, 6px)".concat(" ", "var(--ds-space-050, 4px)", " ", "var(--ds-space-300, 24px)"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  width: "".concat(FILE_WIDTH, "px"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  minHeight: "".concat(MEDIA_HEIGHT, "px"),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});
var dropLineStyles = css({
  background: "var(--ds-border-focused, ".concat(B200, ")"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  borderRadius: "".concat(borderRadius(), "px"),
  margin: "var(--ds-space-025, 2px)".concat(" 0"),
  width: '100%',
  height: '2px'
});
var IconWrapperComponent = function IconWrapperComponent(props) {
  var intl = props.intl;
  var dropPlaceholderLabel = dropPlaceholderMessages.dropPlaceholderLabel;
  return jsx("div", {
    css: iconWrapperStyles
  }, jsx(DocumentFilledIcon, {
    label: intl.formatMessage(dropPlaceholderLabel),
    size: "medium"
  }));
};
var IntlIconWrapper = injectIntl(IconWrapperComponent);
export default (function (_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'group' : _ref$type;
  return type === 'single' ? jsx("div", {
    css: dropLineStyles
  }) : jsx(IntlIconWrapper, null);
});